<!--<app-attention></app-attention>-->
<app-header (mouseleave)="onMouseLeave($event)"></app-header>
<div id="main-content" class="main-block">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
<div id="spinner" [hidden]="!showSpinner">
  <img [lazyLoad]="cdnPath + '/assets/img/loader.gif'"/>
</div>
